<template>
    <div class="homeIndex">
        <section class="topBox">
            <!--  头部搜索框 START -->
            <!--            <div class="searchBox flex_box justify-content_flex-justify">
                            <p class="borderHalf"></p>
                            <div class="searchBar">
                                <input type="text" placeholder="搜索企业/人物/舆情">
                            </div>
                            <img class="setImg" src="../assets/img/setIcon.svg" alt="设置按钮">
                        </div>-->
            <!--  头部搜索框 END -->
            <!--  头部内容 -->
            <div class="topContent">
                <div class="flex_box justify-content_flex-justify align-items_center">
                    <div>
                        <p class="fs20 co_fff font_b">金融业舆情健康指数</p>
                        <p class="fs12 co_fff8 flex_box time_box">
                            {{ industry.updatedAt | formatDate }}
                            <question-box class="ml5  flex_box align-items_center "
                                          msg="基于全网舆情数据，以正面及中性舆情影响力在整体舆情影响力中的占比为核心，运用人工智能分析处理技术、进行归一化运算得出舆情健康指数。"></question-box>
                        </p>
                    </div>
                    <p class="co_fff"><span class="fs42 font_b">{{ industry.score }}</span><span class="fs14">分</span>
                    </p>
                </div>
            </div>
            <!--  行业排名 -->
            <ScoreRank v-if="subIndustryRank" :render-data="subIndustryRank"></ScoreRank>
            <!--  头部导航 -->
            <div class="topNav flex_box justify-content_flex-justify">
                <div v-for="item in topNav" :key="item.name" class="text_c" @click="clickNav(item)">
                    <img class="imgBox" :src="item.icon" alt="">
                    <p class="fs14 navName">{{ item.name }}</p>
                </div>
            </div>
        </section>
        <!--  主要切换内容 -->
        <section class="mainContent">
            <div class="navBgCommon">
                <p class="borderHalf"></p>
                <ul class="commonNav flex_box justify-content_flex-justify">
                    <li v-for="item in mainNav" :key="item" :class="{ active: activeNav === item }"
                        @click="activeNav = item">
                        <p class="fs16">{{ item }}</p>
                        <p class="subLine"></p>
                    </li>
                </ul>
            </div>
            <!-- 显示替换内容 -->
            <div v-if="activeNav === '舆情总览' && industryFameStats">
                <LineChart
                    v-if="industryFameStats"
                    @checkDetail="toEventList"
                    controlTitle="全部事件"
                    :renderData="industryFameStats.fameHealthTrend"
                    :mainChief="industryFameStats.mainChief"
                    :articleCount="articleCount"
                    :subjectArticleCount="subjectArticleCount"
                    :formatxAxisDate="formatLineChartxAxisDate"
                />
                <p class="chartLine"></p>
                <ArticleCountMapChart
                    v-if="industryFameStats"
                    :renderData="industryFameStats.provinceArticle"
                    entityType="industry"
                    title="舆情报道分布">
                </ArticleCountMapChart>
                <p class="chartLine"></p>
                <!--                <HealthRank-->
                <!--                    v-if="industryRiskStats"-->
                <!--                    :renderData="industryRiskStats.newCompanyHealthyRank"-->
                <!--                    :onlyList="false"-->
                <!--                    :getMore="true"-->
                <!--                />-->
                <!--                <p class="chartLine"></p>-->
                <PieChart v-if="industryFameStats"
                          chartTitle="影响力等级"
                          :isEffect="true"
                          chartShowEntityCountUnit="篇"
                          :renderData="industryFameStats.broadcastEffect"
                          :yesterdayData="industryFameStats.broadcastEffectYesterday"
                          :mainAffectEventByTendency="industryFameStats.mainAffectEventByTendency"
                          :effectForwardCountsByTendency="industryFameStats.effectForwardCountsByTendency">
                </PieChart>
                <EventStatsBar
                    v-if="industryFameStats"
                    :renderData="industryFameStats"
                    class="mb20">
                </EventStatsBar>
            </div>

            <div v-if="activeNav === '风险分析'">
                <BarChartCrosswise
                    entityType="industry"
                    riskType="yinbaoRisk"
                    title="风险概况"
                    v-if="industryRiskStats"
                    :setContent="setRiskContent"
                    :renderData="industryRiskStats.general.yinbaoRiskCounts"
                    :tagNum=10 />
                <BarChartCrosswise
                        entityType="industry"
                       :onlyChart="true"
                       v-if="industryRiskStats"
                       firstTitle="主要内容风险点"
                       chartTitle="主要内容风险点"
                       :renderData="industryRiskStats.general.riskCategoryCountList"
                        :tagNum=10
                ></BarChartCrosswise>
                <PieChart v-if="industryFameStats"
                          title="风险等级占比"
                          chartId="PieChartGeneral"
                          :onlyChart="true"
                          :hasIcon="true"
                          imgClass="textIcon"
                          :riskLevelStr="riskLevelStr"
                          chartShowEntityCountUnit="件"
                          :renderData="industryRiskStats.general.riskLevelCountList"/>
            </div>
            <div v-if="activeNav === '媒体口碑'">
                <TendencyChart class="TendencyChart" v-if="industryFameStats"
                               :channelStats="industryFameStats.channelTendency" :hasTitle="true"
                               entity="金融" entityType="industry"></TendencyChart>
                <p class="chartLine"></p>
                <MediaReports
                    entityType="industry"
                    entity="金融"
                    title="媒体报道倾向"
                    tendency="negative"
                    :articleCount="negArticleCount"
                    :renderData='industryRiskStats.mediaReportTendency.list'/>

                <p class="chartLine"></p>
                <TendencyChart v-if="industryFameStats"
                               class="TendencyChart"
                               :channelStats="industryFameStats.riskCompanies"
                               :defaultContent="setCompanyContent" title="涉企敏感报道"
                               key="companyHealthRank"
                               chartBox="companyHealthRank"
                               :hasTitle="true"
                               :hasHint="true"
                ></TendencyChart>
            </div>
            <div v-if="activeNav === '实时报道'">
                <ArticleList v-if="industryFameStats"
                             title="实时报道"
                             entity="article"
                             @checkMore="checkMoreArticle"
                             :renderData="industryFameStats.reportTop5"
                             :assignPositive="true"/>
            </div>
        </section>
        <FootBar selected="home"></FootBar>
        <!-- loading box -->
        <LoadingPage :loading="loading"/>

    </div>
</template>

<script>
import moment from "moment"
import common from "@/util/common";
import _ from 'lodash'

const smartRank = require('../assets/img/industry/smartRank.png')
const dateContrast = require('../assets/img/industry/dateContrast.png')
const selfReport = require('../assets/img/industry/selfReport.png')
const companyDistribute = require('../assets/img/industry/companyDistribute.png')

export default {
    name: 'Home',
    components: {
        FootBar(render) {
            require(["@/components/common/Tabbar"], render)
        },
        QuestionBox(render) {
            require(["@/components/common/QuestionBox"], render)
        },
        ScoreRank(render) {
            require(["@/components/entity/ScoreRank"], render)
        },
        LineChart(render) {
            require(["@/components/chart/LineChart"], render)
        },
        ArticleCountMapChart(render) {
            require(["@/components/chart/ArticleCountMapChart"], render)
        },
        // HealthRank(render){
        //     require(["@/components/entity/HealthRank"], render)
        // },
        PieChart(render) {
            require(["@/components/chart/PieChart"], render)
        },
        EventStatsBar(render) {
            require(["@/components/entity/EventStatsBar"], render)
        },
        BarChartCrosswise(render) {
            require(["@/components/chart/BarChartCrosswise"], render)
        },
        ArticleList(render) {
            require(["@/components/entity/ArticleList"], render)
        },
        TendencyChart(render) {
            require(["@/components/chart/TendencyChart"], render)
        },
        MediaReports(render) {
            require(["@/components/entity/MediaReports"], render)
        },
        LoadingPage(render) {
            require(["@/components/common/LoadingPage"], render)
        },

    },
    props: {},
    data() {
        return {
            formatLineChartxAxisDate: true,
            loading: false,
            sourceData: null,
            topNav: [
                {name: '智能榜单', icon: smartRank, path: '/rankChoosePage'},
                {name: '数据对比', icon: dateContrast, path: '/choosePage?type=compare'},
                {name: '自助报告', icon: selfReport, path: '/reports'},
                {name: '企业分布', icon: companyDistribute, path: '/enterpriseDistribution'},
            ],
            mainNav: ['舆情总览', '风险分析', '媒体口碑', '实时报道'],
            activeNav: '舆情总览',
            subIndustryRank: null, // 行业排行
            industryFameStats: null, // 行业 舆情
            industryRiskStats: null, // 行业 舆情
            industry: {
                score: 0,
                updatedAt: new Date()
            },
            mediaReportContent: null,
            setRiskContent: null, // 风险概况的文案
            setCompanyContent: null, // 涉企敏感报道
            articleCount: 0,//报道总量
            subjectArticleCount: 0,//主体报道总量
            negArticleCount: 0,
            riskLevelStr: "" // 风险等级占比文案
        }
    },
    filters: {
        formatDate(data) {
            return moment(data).format('YYYY年M月D日')
        }
    },
    mounted() {
        this.getData()
    },
    methods: {
        async getData() {
            this.loading = true;
            let res = await this.baseApi.getIndustry('金融');
            if (res !== 'confirm') {
                this.sourceData = res
                let {subIndustryRank, industry, industryFameStats, industryRiskStats, subjectArticleCount} = res;
                this.subIndustryRank = subIndustryRank;
                this.industry = industry;

                this.industryRiskStats = industryRiskStats;
                this.industryFameStats = industryFameStats;

                // 风险概况 文案设置
                this.setRiskContent = common.industryRiskContent(industryRiskStats.general, "金融业");

                //媒体口碑 涉企敏感报道
                let {riskCompanies = [], companyRiskEvents = []} = industryFameStats;

                let riskCompanyNames = [];
                this.setCompanyContent = `今日，暂无涉企敏感报道。`;

                if (riskCompanies.length) {
                    let maxNeg = riskCompanies[0].negative;
                    riskCompanyNames = _.chain(riskCompanies).filter({negative: maxNeg}).map('name').value();
                    this.setCompanyContent = `今日，${riskCompanyNames.join('、')}敏感报道相对较多，${riskCompanyNames.length > 1 ? "各" : "达"}<b>${maxNeg}篇</b>`;
                }
                _.forEach(companyRiskEvents, (info, index)=>{
                    this.setCompanyContent += `${index ? "、" : "；"}${riskCompanyNames[index]}主要受敏感事件《<a href=${info.uri} class="co_333" target="_blank"><b>${info.title}</b></a>》` ;
                })

                this.setCompanyContent += companyRiskEvents.length ? `广泛传播影响。` : "。";

                // 处理chart显示的事件数/文章数
                let {broadcastEffect, effectForwardCounts} = industryFameStats;
                if (effectForwardCounts) {
                    _.each(broadcastEffect, item => {
                        let info = _.find(effectForwardCounts, {key: item.level});
                        item.articleCount = info ? info.value : 0;
                    });
                }
                this.articleCount = _.sumBy(industryFameStats.channelTendency,"total");
                this.subjectArticleCount = subjectArticleCount;

                this.negArticleCount = _.sumBy(industryFameStats.channelTendency,"negative");
                // 设置风险占比文案
                this.riskLevelStr = common.getRiskLevelContent('日', '金融', industryRiskStats.general.riskLevelCountList, industryRiskStats.general.highRiskLevelEvents);

            }
            this.loading = false;
        },
        clickNav(item) {
            // if (item.path.indexOf('/choosePage') > -1) {
            //     sessionStorage.clear()
            // }

            this.$router.push((item.path === "/reports" && !common.getUser()) ? "/createReport" : item.path)
        },
        toEventList() {
            this.$router.push('/eventList')
        },
        checkMoreArticle(data) {
            let tendency = data.isPositive ? '正面' : '敏感';
            this.$router.push({path: '/ArticleList', query: {industry: '金融业', tendency}})
        }
    }
}
</script>

<style lang="scss" scoped>

.topContent {
    font-family: PingFangSC-Medium;
    padding: 20px 30px 20px 16px;
}

.topNav {
    width: calc(100vw - 25px);
    height: 88px;
    background-color: #FFFFFF;
    border-radius: 5px;
    margin: 0 auto 13px;
    padding: 14px 17px;

    .imgBox {
        width: 36px;
    }

    .navName {
        font-family: PingFangSC-Medium;
        color: #6087CF;
        margin-top: 5px;
        letter-spacing: 0;
        text-align: center;
        line-height: 14px;
        font-weight: 500;
    }
}

.mainContent {
    margin-top: 60px;
    background-color: #FFFFFF;
    border-radius: 5px;
    overflow: hidden;

    .TendencyChart {
        padding: 16px 0 16px 16px;
    }
}
</style>
